import {
	ChartDataPoint,
	ChartInfo,
	ChartUtilResult,
	RequestEvent,
} from '../components/General/PlayerChart/types';
import {
	Parameter,
	ReplayInteractiveData,
	DateInput,
} from '../pages/InteractiveSimulation/types/replayInteractive';
import dayjs from 'dayjs';


function dateInputToTimestamp(dateInput: DateInput): number {
	if (typeof dateInput === 'number') {
		return dateInput;
	}

	if (typeof dateInput === 'string') {
		const timestamp = dayjs.utc(dateInput).valueOf();
		return timestamp;
	}

	if (dateInput instanceof Date) {
		const localTimeString = dayjs(dateInput).format('YYYY-MM-DD HH:mm:ss');
		const timestamp = dayjs.utc(localTimeString).valueOf();
		return timestamp;
	}

	const localTimeString = dateInput.format('YYYY-MM-DD HH:mm:ss');
	const timestamp = dayjs.utc(localTimeString).valueOf();
	return timestamp;
}


export function transformReplayDataToChartDataWithTimestamp(
	replayData: ReplayInteractiveData[],
	parameters: Parameter[],
): ChartUtilResult[] {
	return parameters.map((parameter) => {
		const chartInfo: ChartInfo = {
			name: `${parameter.infraestructureName} | ${parameter.paremeterName}`,
		};

		const chartDataPoints: ChartDataPoint[] = replayData
			.map((timePoint) => {
				const parameterData = timePoint.data.find(
					(dataPoint) => dataPoint.paramId === parameter.paremeterId.toString(),
				);

				if (parameterData) {

					const timestamp = dateInputToTimestamp(timePoint.time);

					return {
						x: timestamp,
						y: parameterData.value,
					};
				}
				return null;
			})
			.filter((point): point is ChartDataPoint => point !== null);

		return {
			info: chartInfo,
			data: chartDataPoints,
			paramId: parameter.paremeterId.toString(),
		};
	});
}
